import { Component, OnInit } from '@angular/core';
import { ChartOptions } from 'chart.js';
import { BehaviorSubject } from 'rxjs';
import { GraphDataResponse, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { formatDateHuman } from '../../../ui-components/standard-date.pipe';

@Component({
  selector: 'sa-driver-with-completed-loads',
  styleUrls: ['./driver-with-completed-loads.component.scss'],
  templateUrl: './driver-with-completed-loads.component.html',
})
export class DriverWithCompletedLoadsComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public loading = false;
  public timeframe = 3;
  public datasets: GraphDataResponse = this.initializeDriverWithCompletedLoads();
  public isNoDataSubject$$ = new BehaviorSubject<boolean>(true);

  public chartColors: any[] = [
    {
      backgroundColor: ['rgb(32,118,135, 0.5)'],
      borderColor: ['rgb(32,118,135)'],
    },
  ];

  public options: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      this.resetDriverWithCompletedLoads();

      this.regionID = regionID;
      this.fetchDriverWithCompletedLoads();
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.resetDriverWithCompletedLoads();
        this.fracsID = fracsID;
        this.fetchDriverWithCompletedLoads();
      }
    });
  }

  private fetchDriverWithCompletedLoads(): void {
    this.loading = true;
    this.isNoDataSubject$$ = new BehaviorSubject<boolean>(false);
    const driverCompletedLoadsTimeframe = this.kpiDashboardService.getLocalStorage('driver_completed_loads_timeframe');
    if (driverCompletedLoadsTimeframe) {
      this.timeframe = driverCompletedLoadsTimeframe;
    }
    this.kpiDashboardService
      .getDriverWithCompletedLoads$(this.regionID, this.fracsID, this.timeframe)
      .subscribe((data) => {
        this.datasets = data;

        this.datasets.labels.map((label, index) => {
          this.datasets.labels[index] = formatDateHuman(label);
        });

        data.datasets.forEach((value) => {
          const sum = value.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          if (value.data.length !== 0 && sum !== 0) {
            this.isNoDataSubject$$?.next(false);
          } else {
            this.isNoDataSubject$$?.next(true);
          }
        });

        this.loading = false;
      });
  }

  private resetDriverWithCompletedLoads(): void {
    this.datasets = this.initializeDriverWithCompletedLoads();
  }

  private initializeDriverWithCompletedLoads(): GraphDataResponse {
    this.isNoDataSubject$$?.next(true);
    return {
      datasets: [
        {
          data: [0],
          label: '',
        },
      ],
      labels: [''],
    };
  }

  public onTimeframeChange(timeframe: number) {
    this.timeframe = timeframe;
    this.kpiDashboardService.setLocalStorage('driver_completed_loads_timeframe', this.timeframe);
    this.fetchDriverWithCompletedLoads();
  }
}
